import { AspectRatio, Box } from '@vimeo/bokeh';
import { EmbedPlayer } from '@vimeo/embed-player';

import { getEventIdFromClip } from '../utils/helper';
import { Clip } from '../utils/types';

const PLAYER_CARD_ASPECT_RATIO = 16 / 9;

interface Props {
  clip: Clip;
  name: string;
  playerEmbedUrl: string;
  clipId?: string;
  embedPlayerConfigUrl?: string;
}

export const VideoCardPlayer = ({
  clip,
  clipId,
  embedPlayerConfigUrl,
  name,
  playerEmbedUrl,
}: Props) => {
  if (!clipId) return null;

  const eventId = clip && getEventIdFromClip(clip);
  return (
    <Box
      position="relative"
      minW="8rem"
      aspectRatio={PLAYER_CARD_ASPECT_RATIO}
      outline="0"
      borderRadius="md"
      overflow="hidden"
      backgroundColor="black"
      _focusWithin={{ '[data-component-id="decoration-wrapper"]': { opacity: 1 } }}
      data-group
      data-component-id="video-card-thumbnail"
    >
      <AspectRatio ratio={PLAYER_CARD_ASPECT_RATIO}>
        {eventId || !embedPlayerConfigUrl ? (
          <EmbedPlayer key={`${eventId}-embed`} src={playerEmbedUrl} disableAPI />
        ) : (
          <EmbedPlayer title={name} src={playerEmbedUrl} configUrl={embedPlayerConfigUrl} />
        )}
      </AspectRatio>
    </Box>
  );
};
